@if (text) {
  {{ text }}
}
